import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

import {useMicroZoneInfiniteQuery} from "./query";
import {debounce} from "../../../utils/debounce";

import MDInput from "materialDashboard/components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import {getScrollHandler, LoadingAdornment} from "../utils";


const MicroZoneAutocomplete = ({ selectedStation, setSelectedStation, microZoneFilters={}, fieldProps={}, initializeFirst=false, waitFocus=true, ...props }) => {
    const {t} = useTranslation(["inputs"]);
    const hasAutoSelectedRef = useRef(false);

    const [hasFocus, setHasFocus] = useState(false);
    const [microZoneSearch, setStationSearch] = useState("");
    const microZoneSearchQuery = useMicroZoneInfiniteQuery({search: microZoneSearch, ...microZoneFilters}, !waitFocus || hasFocus);
    const microZones = microZoneSearchQuery.data?.pages?.flatMap((page) => page.items) ?? []

    const handleStationSearch = debounce((value) => {
        setStationSearch(value);
    }, 300);

    const microZoneOptions = [
        ...(selectedStation ? [selectedStation] : []),
        ...microZones.filter(s => !selectedStation || selectedStation.id !== s.id)
    ]

    useEffect(() => {
        if (initializeFirst && !selectedStation && microZones.length > 0 && !hasAutoSelectedRef.current) {
            setSelectedStation(microZones[0]);
            hasAutoSelectedRef.current = true;
        }
    }, [initializeFirst, microZones, setSelectedStation]);

    return <Autocomplete
        id="microzone-autocomplete"
        options={microZoneOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(microZone) => [microZone.code, microZone.name].filter(x => x).join(" - ")}
        value={selectedStation}
        defaultValue={selectedStation}
        filterOptions={(x) => x}
        loading={microZoneSearch.isFetching}
        onChange={(e, value) => setSelectedStation(value)}
        onClose={() => handleStationSearch("")}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        ListboxProps={{onScroll: getScrollHandler(microZoneSearchQuery)}}
        renderInput={(params) => (
            <MDInput {...params}
                     onChange={(e) => handleStationSearch(e.target.value)}
                     variant="standard"
                     label={t('microZoneAutocomplete.label')}
                     placeholder={t('microZoneAutocomplete.placeholder')}
                     InputProps={{
                         ...params.InputProps,
                         endAdornment: (<LoadingAdornment infiniteQuery={microZoneSearchQuery} params={params} /> ),
                     }}
                     {...fieldProps}
            />
        )}
        {...props}
    />
}

export default MicroZoneAutocomplete;